import { checkIsInSkipRange } from "../product-utils";
export var isRowSkipped = function(values, row) {
    var ref;
    var findIsSkipped = checkIsInSkipRange((ref = values === null || values === void 0 ? void 0 : values.skipRange) !== null && ref !== void 0 ? ref : []);
    return findIsSkipped(row.order);
};
